<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>공지사항</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>공지사항</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="table_search">
            <div class="select">
              <select name="" id="" v-model="params.searchType">
                <option :value="1">제목</option>
                <option :value="2">내용</option>
                <option :value="3">제목+내용</option>
              </select>
            </div>
            <div class="search_wrap">
              <div class="input">
                <input
                  type="search"
                  placeholder="검색"
                  v-model="params.searchText"
                  @keyup.enter="fetchData(1)"
                />
              </div>
              <button class="btn" @click="fetchData(1)">검색</button>
            </div>
          </div>
          <news-list :items="items" :pageInfo="pageInfo" @view="fnView" />
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import NewsList from '@/components/pages/news/list/index'
export default {
  name: 'manager-exam-notice-index',
  description: '공지사항',
  components: { NewsList },
  data: function() {
    return {
      params: {
        page: 1,
        limit: 10,
        searchType: 1,
        searchText: ''
      },
      items: [],
      pageInfo: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$ManagerSvc.getListBoxExamNotice(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnView: function(item) {
      this.$router.push({
        path: '/manager/exam/notice/view',
        query: { noticeNo: item.noticeNo }
      })
    }
  }
}
</script>

<style scoped></style>
